module.exports = __webpack_public_path__ + "img/no-preview.996812ca.png";